import {
  isAuth0Enabled,
  signOut,
  getSignedUserInfo,
  isAuth0LoginEnabled,
} from '../great-pet-account'
import { userIcon } from './user-icon'

export default async function () {
  if (isAuth0Enabled() && isAuth0LoginEnabled()) {
    const login = document.querySelector('.MainHeaderLogin')

    if (login) {
      login.addEventListener('click', async (e) => {
        e.preventDefault()
        await auth0WordpressPlugin.loginWithRedirect()
        return true
      })
    }
  }

  const user = await getSignedUserInfo()

  if (user) {
    createSignedUserMenu(user?.firstName || '')
  }
}

function createSignedUserMenu(name) {
  const searchToolDesktop = document.querySelector('.SearchToolDesktop')
  const mainHeaderLogin = document.querySelector('.MainHeaderLogin')
  const signedUserMenu = document.createElement('div')
  const signedUserMenuButton = document.createElement('button')
  const signedUserMenuImage = document.createElement('span')
  const signedUserMenuName = document.createElement('span')
  const mobileMenuSignInLink = document.querySelector(
    '.MobileMenu .MainHeaderLogin'
  )

  if (mobileMenuSignInLink) {
    mobileMenuSignInLink.remove()
  }

  signedUserMenu.classList.add('SignedUserMenu')
  signedUserMenuButton.classList.add('SignedUserMenu__container')
  signedUserMenuImage.classList.add('SignedUserMenu__container__image')

  if (name) {
    signedUserMenuName.textContent = name
    signedUserMenuName.classList.add('SignedUserMenu__container__name')
  }

  signedUserMenuImage.innerHTML = name && name.length > 0 ? name[0] : userIcon

  signedUserMenu.appendChild(signedUserMenuButton)
  signedUserMenuButton.appendChild(signedUserMenuImage)
  signedUserMenuButton.appendChild(signedUserMenuName)

  if (searchToolDesktop && mainHeaderLogin) {
    mainHeaderLogin.remove()
    searchToolDesktop.insertAdjacentElement('afterend', signedUserMenu)

    createSignedMenuItens()
    return true
  }

  return false
}

function createSignedMenuItens() {
  const signedUserMenuButton = document.querySelector(
    '.SignedUserMenu__container'
  )
  const signedUserMenuItems = document.createElement('div')
  const signedUserMenuItemsWrapper = document.createElement('div')
  const signedUserMenuItemMyAcc = document.createElement('a')
  const signedUserMenuItemSignOut = document.createElement('button')

  signedUserMenuItems.classList.add('SignedUserMenu__menuItems')
  signedUserMenuItemsWrapper.classList.add('SignedUserMenu__menuItems__wrapper')
  signedUserMenuItemMyAcc.classList.add(
    'SignedUserMenu__menuItems__wrapper__menuItem'
  )
  signedUserMenuItemSignOut.classList.add(
    'SignedUserMenu__menuItems__wrapper__menuItem'
  )

  signedUserMenuItemMyAcc.textContent = 'My Account'
  signedUserMenuItemSignOut.textContent = 'Sign Out'
  signedUserMenuItemSignOut.type = 'button'
  signedUserMenuItemMyAcc.href =
    request?.greatPetAccountLink || 'https://account.greatpetcare.com/'
  signedUserMenuItemMyAcc.target = '_blank'

  signedUserMenuItems.appendChild(signedUserMenuItemsWrapper)
  signedUserMenuItemsWrapper.appendChild(signedUserMenuItemMyAcc)
  signedUserMenuItemsWrapper.appendChild(signedUserMenuItemSignOut)

  if (signedUserMenuButton) {
    signedUserMenuButton.insertAdjacentElement('afterend', signedUserMenuItems)

    toggleSignedUserButton()
    signOutButton()
  }
}

function toggleSignedUserButton() {
  const signedUserMenuButton = document.querySelector(
    '.SignedUserMenu__container'
  )
  const signedUserMenuItems = document.querySelector(
    '.SignedUserMenu__menuItems'
  )

  if (!signedUserMenuButton || !signedUserMenuItems) {
    return
  }

  signedUserMenuButton.addEventListener('click', () => {
    signedUserMenuItems.classList.toggle('SignedUserMenu__menuItems--opened')
  })
}

function signOutButton() {
  const signOutButton = document.querySelector(
    '.SignedUserMenu__menuItems__wrapper__menuItem[type="button"]'
  )

  signOutButton.addEventListener('click', () => {
    signOut()
  })
}
